import { render, staticRenderFns } from "./salarySetList.vue?vue&type=template&id=73351857&scoped=true&"
import script from "./salarySetList.vue?vue&type=script&lang=js&"
export * from "./salarySetList.vue?vue&type=script&lang=js&"
import style0 from "./salarySetList.vue?vue&type=style&index=0&id=73351857&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73351857",
  null
  
)

component.options.__file = "salarySetList.vue"
export default component.exports